/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Theme_ToggleInputs */

const en_common_theme_toggle = /** @type {(inputs: Common_Theme_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const zh_common_theme_toggle = /** @type {(inputs: Common_Theme_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换主题`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Common_Theme_ToggleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_theme_toggle = /** @type {((inputs?: Common_Theme_ToggleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Theme_ToggleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_theme_toggle(inputs)
	return zh_common_theme_toggle(inputs)
});
export { common_theme_toggle as "common.theme.toggle" }